import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { DocInfoModalComponent } from 'src/app/modals/doc-info-modal/doc-info-modal.component';
import { DoctorService } from 'src/app/services/doctor.service';
import { AlertService } from '../../../lib/ariadna/alert';
import {
    IDoctorSearchResult,
    IDoctor,
    IRnumbDate,
    IServ,
    ISpec,
    IStaticFilter,
} from '../../interfaces/record.interfaces';
import { HttpNewService } from '../../services/application/http-new.service';
import { RecordService } from '../../services/record.service';

import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { rightPanelAnimation } from 'src/app/animations/height.animation';
import { ServModalComponent } from 'src/app/modals/service-modal/service-modal.component';
import { ConfigService } from 'src/app/services/application/config.service.';
import { LoadService } from 'src/app/services/application/load.service';
import { toDateTime } from 'src/app/shared/date/date.utils';
import { Utils } from 'src/app/services/utils';
import { strToDate } from '../application/global.function';

@Component({
    selector: 'rec-services',
    templateUrl: './rec-services.component.html',
    styleUrls: ['./rec-services.component.scss'],
    animations: [rightPanelAnimation],
    standalone: false
})
export class RecServicesComponent implements OnInit {
    private abortController: AbortController | null = null;
    public constructor(
        private httpService: HttpNewService,
        private alertService: AlertService,
        private rs: RecordService,
        private config: ConfigService,
        private load: LoadService,
        private title: Title,
        private modalService: NgbModal,
        private recordService: RecordService,
        private doctorInfoService: DoctorService,
        private cdref: ChangeDetectorRef,
        private elementRef: ElementRef,
    ) {
        const tmpTitle =
            load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.RECORD_SERVICES
                .TITLE;
        if (tmpTitle) this.title.setTitle(tmpTitle);
    }

    public filterSearchText: string = '';
    public panelSetStyleRnum = {
        height: '100%',
        'box-shadow': '-7px 3px 4px 0px rgb(212 212 212 / 50%)',
    };
    public panelSetStyle = { height: '100%' };
    public loadingServices = true;
    public loadingDoctors = false;
    public loadingImgUrl = './assets/loading-rec.gif';
    public filterList: IStaticFilter[] = [];

    public selectedSrv: IServ | undefined;
    public selectedDoctor: IDoctorSearchResult | undefined;
    // filterSearchText = '';
    public services: IServ[] = [];
    public doctors: IDoctorSearchResult[] | undefined;
    public paramsTalonPicker!: IRnumbDate;
    public staticFilterBTNs: IStaticFilter[] = []; // Список кнопок
    public selectedFilter: IStaticFilter | null = null; //Список сервисов
    public isDropdownOpen = true;
    public isMobileFlilterOpen = false;
    public showDoctors = true;
    public showTalonPicker = false;
    public talonPickerAnime = 'off';
    public staticFilterSelected: any;
    public searchAmine: any;
    public activeItem: any;
    public selectedService: ISpec | null = null; // для плейсхолдера
    public selectedSpec: ISpec | null = null;

    public dtBegin: Date | null = null; // Дата начала
    public dtEnd: Date | null = null; // Дата ококнчания
    public orderUP = true; // С начала последние
    public orderUPText: string = 'Сначала последние';

    // recDoctors: IDoctor[] | null = null;
    public recDoctorsFullList: IDoctor[] | null = null;
    public loadingListDoc: boolean = false;
    public recListLength: number = 0; // Количество записей

    public periodStart: Date = new Date();
    // periodEnd: Date = new Date();
    public periodEnd = toDateTime(this.periodStart)
        .plus({ days: 30 })
        .toJSDate();
    public filterSearchControl = new FormControl();

    @HostListener('document:click', ['$event'])
    @ViewChild('filterSearchText')
    public filterSearchInput: ElementRef | undefined;
    public filteredServices: any[] = [];
    public window = window;
    public openMobileTemplate = false;

    public ngOnInit(): void {
        this.filteredServices = this.services;
        this.getServicesFullList(null);
        lastValueFrom(this.recordService.getStacfilterList())
            .then((data: IStaticFilter[]) => {
                this.filterList = data;
            })
            .catch((error) => {
                this.alertService.error(
                    Utils.getErrorMessage(
                        error,
                        'Не удалось загрузить список услуг по данному фильтру.',
                    ),
                );
            });
        this.filterSearchControl.valueChanges.subscribe((value) => {
            this.filterSearchText = value;
            this.filteredServices = this.services.filter((serv) =>
                serv.text
                    .toString()
                    .toLowerCase()
                    .includes(this.filterSearchText.toString().toLowerCase()),
            );
        });
        if (this.filterSearchInput) {
            this.filterSearchInput.nativeElement.addEventListener(
                'input',
                () => {
                    this.onFilterInput();
                },
            );
        }
    }

    public onFilterInput(event?: Event): void {
        if (this.filterSearchInput) {
            this.filterSearchText = this.filterSearchInput.nativeElement.value;
            this.filteredServices = this.services.filter((service) =>
                service.text
                    .toLowerCase()
                    .includes(this.filterSearchText.toLowerCase()),
            );
        }
        const input = event?.target as HTMLInputElement;
        if (input.value === '') {
            this.clearFilterSearchText();
        }
    }
    public experienceText(exp: string | undefined): string {
        return Utils.experienceText(exp);
    }

    public filterServices() {
        if (!this.filterSearchText) {
            return this.services;
        }

        return this.services.filter((service) =>
            service.text
                .toLowerCase()
                .includes(this.filterSearchText.toLowerCase()),
        );
    }

    public ngAfterViewInit(): void {
        if (this.filterSearchInput) {
            this.filterSearchInput.nativeElement.addEventListener(
                'input',
                () => {
                    this.onFilterInput();
                },
            );
        }
        const options = document.querySelectorAll('.filter__option');
        options.forEach((option, index) => {
            (option as HTMLElement).style.setProperty(
                '--item-index',
                String(index + 1),
            );
        });
    }

    public ngOnDestroy() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
    }

    public async getServicesFullList(value: number | null) {
        this.loadingServices = true;
        this.staticFilterSelected = value;
        this.showTalonPicker = false;

        try {
            const res: IServ[] = await lastValueFrom(
                this.httpService.post<Array<IServ>>(
                    '/record/rnumb/services-full-list',
                    {
                        stacId: value ?? null,
                    },
                ),
            );

            if (!res) {
                this.alertService.error(
                    'Нет свободных врачей на даннную услугу',
                );
            }

            this.services = res.sort((a, b) => {
                const aText = a.text.toUpperCase(),
                    bText = b.text.toUpperCase();
                if (aText < bText) {
                    return -1;
                }
                if (aText > bText) {
                    return 1;
                }
                return 0;
            });

            this.loadingServices = false;
        } catch (e) {
            console.log(e);
        } finally {
            this.loadingServices = false; //скрываем loader
            this.isDropdownOpen = true;
        }
    }

    public isEmptyObject(obj: Object) {
        return JSON.stringify(obj) === '{}';
    }

    public async pickDoctor(doctor: IDoctorSearchResult) {
        try {
            this.selectedDoctor = doctor;
            this.selectedSpec =
                this.selectedSpec ??
                ({
                    keyId: doctor.specId,
                    text: doctor.specid_1,
                } as ISpec);

            const periodStart = new Date();
            const periodEnd = toDateTime(periodStart)
                .plus({ days: 30 })
                .toJSDate();

            this.paramsTalonPicker = {
                doctorId: this.selectedDoctor.docId,
                specId: this.selectedDoctor.specId,
                periodStart,
                periodEnd,
                srv: this.selectedSrv,
                infoDoc: doctor.info,
                depId: null,
            };

            if (window.innerWidth < 500) {
                this.selectedDoctor = doctor;
                this.openMobileTemplate = true;
                this.showDoctors = false;
            } else {
                this.showTalonPicker = true;
            }

            this.talonPickerAnime = 'on';
        } catch (e) {
            console.log(e);
        }
        this.activeItem = doctor;
    }

    //проверка данных

    public async pickService(service: IServ) {
        this.selectedService = service;
        this.filterSearchText = service.text ?? '';
        try {
            if (this.abortController) {
                this.abortController.abort();
            }

            const currentController = new AbortController();
            this.abortController = currentController;
            this.selectedSrv = service;
            this.loadingDoctors = true;

            // Получаем список врачей по выбранной услуге
            const res = await lastValueFrom(
                this.httpService.get<Array<IDoctorSearchResult>>(
                    '/doctor/find_by_service',
                    { srvId: service.keyId },
                    undefined,
                    null,
                    currentController.signal,
                ),
            );

            // Фильтруем только существующих врачей
            this.doctors = res.filter(Boolean);

            if (!this.doctors || this.doctors.length === 0) return;

            // Параллельно загружаем информацию о каждом враче
            const doctorPromises = this.doctors.map(async (doc) => {
                const result = await firstValueFrom(
                    this.doctorInfoService.getDocAboutInfo(doc.docId),
                );

                if (result?.length) {
                    return {
                        ...doc,
                        info: result,
                        workExp:
                            result.find((v) =>
                                v.queston?.toLowerCase().includes('стаж'),
                            )?.answer || '',
                        workSpec:
                            result.find((v) => {
                                if (!v.queston || typeof v.queston !== 'string')
                                    return false;
                                const normalizedQuestion = v.queston
                                    .toLowerCase()
                                    .replace(/[^a-zа-яё0-9]/gi, '');
                                return (
                                    normalizedQuestion === 'направлениеприема'
                                );
                            })?.answer || '',
                    };
                }

                return doc;
            });

            // Ожидаем завершения всех промисов и удаляем дубликаты по docid
            const updatedDoctors = await Promise.all(doctorPromises);
            // повторно проверяем не отменен ли запрос перед обновлением интерфейса
            if (currentController.signal.aborted) return;
            this.doctors = Array.from(
                new Map(
                    updatedDoctors
                        .filter((doc) => doc.docId !== undefined)
                        .map((doc) => [doc.docId!, doc]),
                ).values(),
            );

            this.showDoctors = true;

            // ✅ Создаём массив уникальных специальностей
            const specList = [
                ...new Set(this.doctors?.map((d) => d.specId) ?? []),
            ];

            // ⚡ Вызываем getDocList только для уникальных специальностей
            specList.forEach((spec) => this.getDocList(spec, null));

            // Обновляем состояние интерфейса
            this.isDropdownOpen = false;
            this.loadingDoctors = false;
            this.filterSearchControl.setValue(this.selectedService?.text ?? '');
        } catch (e: any) {
            if (e.name === 'AbortError' || e.name === 'CanceledError') {
                return;
            }
            if (Utils.errorTypeGuard(e).statusCode === 400) {
                this.alertService.error(Utils.getErrorMessage(e));
            } else {
                console.error('Ошибка при выборе услуги:', e);
            }
        } finally {
            if (this.abortController?.signal.aborted)
                this.loadingDoctors = false;
        }
    }

    public getDocImg(id: number | undefined) {
        return `${this.config.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    public getDocImgDefault(event: Event) {
        const elem = event.target as HTMLImageElement;
        // elem.src = `${this.config.getValue('hostBackend')}/img/doc/not.png`;
        elem.src = './assets/images/placeholders/doctor-photo.png';
    }

    public openServModal(serv: IServ, event: Event) {
        event.stopPropagation();
        const modal = this.modalService.open(ServModalComponent);
        modal.componentInstance.serv = serv;
    }
    public openDocInfoModal(
        doc: IDoctorSearchResult | undefined,
        event: Event,
    ) {
        this.selectedDoctor = doc;
        const Idoc: Partial<IDoctor> = {
            doctorId: doc?.docId as number,
            lName: doc?.text.split(' ')[0] as string,
            fName: doc?.text.split(' ')[1] as string,
            sName: doc?.text.split(' ')[2] as string,
            infoDoc: doc?.info,
        };
        event.stopPropagation();
        if (this.selectedDoctor) {
            const modal = this.modalService.open(DocInfoModalComponent);
            modal.componentInstance.doc = Idoc;
            modal.componentInstance.spec = this.selectedDoctor?.specid_1;
        }
    }

    public selectFilter(filter: IStaticFilter): void {
        this.doctors = [];
        if (this.selectedFilter !== filter) {
            this.selectedFilter = filter;
            this.doctors = [];
            this.filterSearchText = '';

            this.getServicesFullList(this.selectedFilter.keyId);
        } else {
            this.selectedFilter = null;
            this.doctors = [];
            this.filterSearchText = '';
            this.getServicesFullList(null);
        }
        this.toggleDropdown();
    }

    public toggleDropdown(): void {
        this.cdref.detectChanges();
        this.searchAmine = true;
    }

    public onTalonPickerClosed() {
        this.showTalonPicker = false;
    }

    public rcountText(count: number): string {
        if (!count) return 'Нет номерков';

        const lastDigit = count % 10;
        const lastTwoDigits = count % 100;

        if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
            return `Осталось ${count} номерков`;
        }

        switch (lastDigit) {
            case 1:
                return `Остался ${count} номерок`;
            case 2:
            case 3:
            case 4:
                return `Осталось ${count} номерка`;
            default:
                return `Осталось ${count} номерков`;
        }
    }
    // Получить список специальностей
    public getDocList(p_SpecID: number, depId: number | null) {
        this.loadingListDoc = true;

        if (this.abortController) this.abortController.abort();
        const currentController = new AbortController();
        this.abortController = currentController;

        let staticId: number | null = null;
        if (this.staticFilterSelected && this.staticFilterSelected.keyid) {
            staticId = this.staticFilterSelected.keyid;
        }

        lastValueFrom(
            this.rs.getDocList(
                p_SpecID,
                this.periodStart,
                this.periodEnd,
                staticId,
                depId,
                currentController.signal,
            ),
        )
            .then((val) => {
                const newDocs = val.filter(
                    (doc) =>
                        !this.recDoctorsFullList?.some(
                            (fullDoc) => fullDoc.doctorId === doc.doctorId,
                        ),
                );

                this.recDoctorsFullList = [
                    ...(this.recDoctorsFullList ? this.recDoctorsFullList : []),
                    ...newDocs,
                ];

                this.recDoctorsFullList.forEach((item) => {
                    item.rdatemin = strToDate(item.datBgn);
                    item.rdatemax = strToDate(item.datEnd);
                });

                this.doctors?.forEach((item, index) => {
                    if (item.docId !== undefined) {
                        item.rcount =
                            this.recDoctorsFullList?.find(
                                (doc) =>
                                    doc.doctorId !== undefined &&
                                    doc.doctorId === item.docId,
                            )?.rCount ?? null;
                    }
                });
            })
            .catch((error) => {
                if (
                    error.name === 'AbortError' ||
                    error.name === 'CanceledError'
                )
                    return;
                console.error('Error fetching doctor list:', error);
                this.alertService.error(
                    'Не удалось загрузить список врачей на данную услугу.',
                );
            })
            .finally(() => {
                this.loadingListDoc = false;
            });
    }

    public onFilterChanged(event: any) {
        switch (event.typeEvent) {
            case 'clearFilter':
                // this.filterList = event.data;
                this.staticFilterSelected = null;
                this.toggleDropdown();
                this.getServicesFullList(null);
                this.filterSearchText = '';
                this.doctors = [];
                break;

            case 'getStacFilters':
                this.filterList = event.data;
                break;

            case 'filterListUpdated':
                this.getServicesFullList(event.data || null);
                this.cdref.detectChanges();
                this.staticFilterSelected = event.data;
                this.filterSearchText = '';
                this.doctors = [];
                // this.toggleDropdown();
                this.isMobileFlilterOpen = false;
                break;
        }
    }
    public formatDoctorName(fullName: string): string {
        const nameParts = fullName.split(' ');
        if (nameParts.length >= 2) {
            const lastName = nameParts[0];
            const initials = nameParts
                .slice(1)
                .map((part) => part.charAt(0) + '.')
                .join('');
            return `${lastName} ${initials}`;
        }
        return fullName;
    }
    public selectService(service: any): void {
        this.isDropdownOpen = false;
    }

    @HostListener('document:click', ['$event'])
    public clickOutside(event: Event) {
        const targetElement = event.target as HTMLElement;

        if (
            // !this.elementRef.nativeElement.contains(targetElement) &&
            !targetElement.classList.contains('filter__dropdown-list') &&
            !targetElement.classList.contains('filterbar__filter')
        ) {
            this.isDropdownOpen = false;
        }
    }

    public mobileFilterHandler() {
        this.isMobileFlilterOpen = !this.isMobileFlilterOpen;
    }
    public closeRegistrationPicker() {
        // this.selectedDoctor = undefined;
        this.showDoctors = true;
        this.openMobileTemplate = false;
    }

    public clearFilterSearchText() {
        this.filterSearchText = '';
        this.filterSearchControl.setValue('');
        this.doctors = [];
        this.showDoctors = false;
        this.isDropdownOpen = true;
        this.cdref.detectChanges();
    }
    public getPlaceholderText(): string {
        return this.selectedService?.text && this.filterSearchText
            ? this.selectedService?.text
            : `Выберите услугу (${this.services.length} шт.)`;
    }
}
